import React, { useEffect, useState } from "react";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import firebase from "firebase";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import {
  Button,
  TextField,
  Typography,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import CardLayout from "../CardLayout";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getUserByEmail, resetAuthDetails } from "redux/actions/userActions";
import {
  callAuth,
  callUnauth,
  checkAuth,
} from "services/firebaseAuthentication";
import {
  DSC,
  ALL_ACTIVITIES,
  MANAGE_ACTIVITY_GROUP,
  INCOMPLETE_PUNCHES,
  MANAGE_TIMESHEET
} from "navigation/CONSTANTS";
import { useHistory } from "react-router-dom";
// import { getRcArrayParam } from "services/firebase";
import { properCase } from "../../../../utils";
import { convertStringToArray } from "utils/rcUtils";
import { useRemoteConfig } from "providers";
const useStyles = makeStyles((theme) => ({
  leftBtn: { textAlign: "left" },
}));

export const AuthView = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const [isDscDisabled, setIsDscDisabled] = useState(true);

  const { isLoading, error, isAuthenticated, user } = useSelector(
    (state) => state.user.auth
  );

  const dscAccess = useRemoteConfig('dscAccess')
  const dscAccessArray = convertStringToArray(dscAccess)

  useEffect(() => {
    setIsDscDisabled(true);
    // console.log("DSC Access Effect Fired")
    if (isAuthenticated) {
      let dscAccessCountries = dscAccessArray;
      console.log("DSC ACCESS", dscAccessCountries);
      if (user && user.country) {
        if (dscAccessCountries.includes(user.country)) {
          setIsDscDisabled(false);
        }
      }
    }
  }, [isAuthenticated, user]);

  // Markup for error on authentication.
  const errMarkup = (
    // <Typography variant="body2" color="error">
    //   {t(error)}
    // </Typography>
    <Alert severity="error">{t(error)}</Alert>
  );

  // Firebase Auth UI
  var uiConfig = {
    callbacks: {
      signInSuccessWithAuthResult: function (authResult, redirectUrl) {
        console.log("signInSuccessWithAuthResult===", authResult);
        return false;
      },
      uiShown: function () {
        // call back
        console.log("google auth done........");
        // document.getElementById("loader").style.display = "none";
      },
    },
    signInFlow: "popup",
    // signInSuccessUrl: "<url-to-redirect-to-on-success>",
    signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
  };

  return (
    <CardLayout
      title={
        isAuthenticated && user.isApprover
          ? properCase(t("pgHome.tlReviewTeam"))
          : properCase(t("pgHome.tlGSuite"))
      }
    >
      {/* tlGSuite & tlReviewTeam */}
      {isLoading ? (
        <CircularProgress />
      ) : !isAuthenticated ? (
        <>
          <StyledFirebaseAuth
            uiCallback={(ui) => {
              console.log("ui: ", ui);
            }}
            uiConfig={uiConfig}
            firebaseAuth={firebase.auth()}
          />

          {error && !isLoading && errMarkup}
        </>
      ) : (
        user.isApprover && (
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                color="primary"
                onClick={() =>
                  history.push(MANAGE_TIMESHEET, { isTimesheetView: true })
                }
                className={classes.leftBtn}
              >
                {t("pgHome.btnReviewPunches")}
              </Button>
            </Grid>

            {!isDscDisabled && (
              <Grid item xs={6}>
                <Button
                  color="primary"
                  onClick={() => history.push(DSC, { isDscView: true })}
                  className={classes.leftBtn}
                >
                  {t("other.dscTitle")}
                </Button>
              </Grid>
            )}
            <Grid item xs={6}>
              <Button
                color="primary"
                onClick={() =>
                  history.push(MANAGE_ACTIVITY_GROUP, {
                    isManageActivityGroup: true,
                  })
                }
                className={classes.leftBtn}
              >
                {t("other.titleManageActivityGroup")}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                color="primary"
                onClick={() => history.push(INCOMPLETE_PUNCHES)}
                className={classes.leftBtn}
              >
                {t("other.lblIncompleteActivities")}
              </Button>
            </Grid>
          </Grid>
        )
      )}
    </CardLayout>
  );
};

export default AuthView;
